export default __webpack_public_path__ + "static/media/il.686ed79d.svg";